const billingPlans: Record<string, Record<string, Record<string, string>>> = {
  basic: {
    monthly: {
      production: 'price_1M66nQIWg5hOg6PDOSVAX9Ng',
      development: 'price_1Qp0MXIWg5hOg6PDlEfmthBY',
    },
    yearly: {
      production: 'price_1O7TtFIWg5hOg6PDzAzt5TWw',
      development: 'price_1Rqo7dIWg5hOg6PDNXRGhjtn',
    },
  },
  plus: {
    monthly: {
      production: 'price_1M66nvIWg5hOg6PDtW1ZJaZO',
      development: 'price_1Rqo8tIWg5hOg6PDA5lKLNUN',
    },
    yearly: {
      production: 'price_1O7TuKIWg5hOg6PDKTQrLnlc',
      development: 'price_1Rqo90IWg5hOg6PDlh7Q2biN',
    },
  },
};

// Helper interface for format-based return types
interface FormatFunction {
  (format: 'text'): string;
  (format: 'value'): number;
  (format?: 'value'): number;
}

function limit(value: number, text: string | undefined = undefined): FormatFunction {
  const fn = (format: 'text' | 'value' = 'value') => {
    return format === 'text' ? text ?? value.toString() : value;
  };
  return fn as FormatFunction;
}

export const planLimits = {
  free: {
    racks: limit(5),
    rooms: limit(0),
    slots: limit(0),
    members: limit(1, 'No'),
  },
  basic: {
    racks: limit(15),
    rooms: limit(3),
    slots: limit(5),
    members: limit(3),
  },
  plus: {
    racks: limit(Infinity, 'Unlimited'),
    rooms: limit(Infinity, 'Unlimited'),
    slots: limit(50),
    members: limit(20),
  },
};

export const getBillingPlan = (plan: string, interval: string) => {
  const mode = import.meta.env.MODE;
  return billingPlans[plan]?.[interval]?.[mode] ?? '';
};
